import { FieldArchivedEvent } from '../event/field-archived.event';
const fieldArchivedProjections = {
    [FieldArchivedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            lifeCycleStatus: payload.lifeCycleStatus,
        };
    },
};
export default fieldArchivedProjections;
//# sourceMappingURL=field-archived.projection.js.map